<template>
	<v-dialog
		v-model="showDialog"
		max-width="600px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn color="secondary" class="mb-2 ml-2" v-bind="attrs" v-on="on">
				<v-icon class="mr-1">mdi-calendar</v-icon>
				部門間調整
			</v-btn>
		</template>

		<v-card :tile="$vuetify.breakpoint.xs">
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">部門間調整</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="closeDialog" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<v-sheet elevation="0" class="pa-2">
				<h6 class="text-h6 font-weight-bold">工程情報</h6>
				<table width="100%" class="show-dialog-table mt-4">
					<tbody>
						<ShowDetailRecord :columnName="'参加者'">
							<template v-slot:value>
								<!-- TODO 参加者一覧 -->
								<template v-if="scheduleArrangementUsers.length">
									<div v-for="user in scheduleArrangementUsers" :key="user.id">
										{{ user.user.full_name }} ({{ user.confirmation_status_i18n }})
									</div>
								</template>
								<template v-else> 現在、参加者はいません。 </template>
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="`${large_process.large_process_type.name}実行想定範囲`">
							<template v-slot:value>
								{{
									common.formatLocalDateWithDay(
										large_process.schedule_arrangement.estimated_start_date
									)
								}}から
								<br />
								{{
									common.formatLocalDateWithDay(
										large_process.schedule_arrangement.estimated_end_date
									)
								}}まで
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="`開始予定日時`">
							<template v-slot:value>
								{{
									common.formatLocalDateTimeWithDay(
										large_process.schedule_arrangement.planned_start_time
									)
								}}
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="`終了予定日時`">
							<template v-slot:value>
								{{
									common.formatLocalDateTimeWithDay(
										large_process.schedule_arrangement.planned_end_time
									)
								}}
							</template>
						</ShowDetailRecord>
					</tbody>
				</table>
				<h6 class="mt-4 text-h6 font-weight-bold">通知送信</h6>
				<v-select
					label="部門"
					v-model="department"
					:items="departments"
					item-text="name"
					item-value="id"
					class="mt-4"
					dense
					outlined
					no-data-text="部門データを取得できていません"
				/>
				<v-autocomplete
					label="対象者"
					v-model="selectedUser"
					:items="users"
					item-text="full_name"
					item-value="id"
					class="mt-4"
					return-object
					dense
					:no-data-text="department ? '部門に所属する社員がいません' : '部門を選択してください'"
					hint="選択したら横のプラスボタンをクリックしてください"
					:persistent-hint="!!selectedUser"
					outlined
					append-outer-icon="mdi-plus-circle"
					@click:append-outer="addUser"
				/>
				<v-row no-gutters>
					<v-chip
						v-for="user in selectedUsers"
						:key="user.id"
						class="ma-1 mt-2"
						close
						label
						outlined
						color="primary"
						@click:close="removeUser(user)"
					>
						{{ user.full_name }}
					</v-chip>
				</v-row>
				<v-row class="my-4" justify="center">
					<v-btn @click="submitForm" dense :disabled="!selectedUsers.length" color="secondary">
						<v-icon class="mr-1">mdi-send</v-icon>
						通知を送信する
					</v-btn>
				</v-row>
			</v-sheet>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import common from "../../../helper/common"
import rules from "../../../helper/rules"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"

export default {
	props: {
		large_process: {
			type: Object,
			required: true,
		},
	},
	components: {
		ShowDetailRecord,
	},
	data() {
		return {
			isFetched: false,
			showDialog: false,
			department: null,
			user: null,
			departments: [],
			selectedUser: null,
			selectedUsers: [],
			common,
			rules,
		}
	},
	methods: {
		fetchData() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/schedule_arrangement_users/new`
			axios
				.get(url, { headers })
				.then((res) => {
					this.departments = res.data.departments
					this.isFetched = true
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		submitForm() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/schedule_arrangements/${this.large_process.schedule_arrangement.id}/schedule_arrangement_users`
			const params = { user_ids: this.selectedUsers.map((u) => u.id) }
			axios
				.post(url, params, { headers })
				.then((res) => {
					// TODO
					this.$emit("add-user", res.data.schedule_arrangement_users)
					this.$store.dispatch("setFlash", {
						text: "日程確認のメッセージを送信しました。",
						type: "notice",
					})
				this.closeDialog()
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		addUser() {
			this.selectedUsers.push(this.selectedUser)
			this.selectedUser = null
		},
		removeUser(user) {
			this.selectedUsers = this.selectedUsers.filter((u) => u.id != user.id)
		},
		filteredScheduleArrangementUser(users) {
			this.selectedUsers
			const filtered_users = users.filter(
				(user) =>
					!this.scheduleArrangementUsers.some((scheduleUser) => scheduleUser.user_id === user.id) &&
					!this.selectedUsers.includes(user)
			)
			return filtered_users
		},
		closeDialog() {
			this.showDialog = false
			this.department = null
			this.selectedUser = null
			this.selectedUsers = []
		}
	},
	computed: {
		users() {
			// TODO 現在選択されている人・参加者は除外する
			const department = this.departments.find((d) => d.id == this.department)
			return department ? this.filteredScheduleArrangementUser(department.users) : []
		},
		scheduleArrangementUsers() {
			// TODO confirmation_statusで絞り込み
			const accepted_users =
				this.large_process.schedule_arrangement.schedule_arrangement_users.filter((user) => {
					return (
						user.confirmation_status == "accepted" ||
						user.confirmation_status == "pending" ||
						user.confirmation_status == "rejected"
					)
				})
			return accepted_users
		},
	},
	watch: {
		showDialog(newVal) {
			if (newVal == true && !this.isFetched) {
				this.fetchData()
			}
		},
	},
}
</script>
